import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";

class ModalAutorenew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            landingpage: false
        };
    };

    componentWillMount() {}

    componentDidMount(){
        this.setState({landingpage: this.props.landingpage});
    }

    _close(){
        this.props.setAutorenew(false);
    }

    _set(){
        this.props.setAutorenew(true);
    }

    _renderText(item) {
        return langRegister.get("modal-autorenew", item);
    }

    render() {
        return (
            <div className={Styles.overlay}>
                <div className={Styles.overlayModal}>
                    <div className={Styles.overlayModalInner}>
                        <img onClick={() => this._close()}
                             className={Styles.overlayCloseButton}
                             src={require("../../assets/images/close_icon.svg")}/>
                        {
                            !this.state.landingpage &&
                            <div>
                                <div className={Styles.overlayModalText}>
                                    <div className={Styles.overlayModalTextGreen}>{this._renderText("item_2")}</div><div>{this._renderText("item_1")}&nbsp;<span className={Styles.overlayModalTextBold}>{this._renderText("item_7")}</span>&nbsp;{this._renderText("item_8")}</div>
                                </div>
                            </div>
                        }
                        {
                            this.state.landingpage &&
                            <div>
                                <div className={Styles.overlayModalText}>
                                    <div className={Styles.overlayModalTextGreen}>{this._renderText("item_6")}</div><div><span className={Styles.overlayModalTextBold}>{this._renderText("item_5")}</span>&nbsp;{this._renderText("item_9")}</div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className={Styles.overlayModalButtons}>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => this._close()}
                                 className={Styles.overlayModalButtonsItemButton}>
                                {this._renderText("item_4")}
                            </div>
                        </div>
                        <div className={Styles.overlayModalButtonsItem}>
                            <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                {this._renderText("item_3")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalAutorenew;


// WEBPACK FOOTER //
// ./src/components/modal-autorenew/component.js